import { createReducer, on } from '@ngrx/store';
import { AvatarNotificationModalActions } from './notification-modal.actions';
import { avatarNotificationModalState } from './notification-modal.state';

/**
 * Reducer for avatar notification modal feature.
 *
 * @exports
 */
export const avatarNotificationModalReducer = createReducer(
  avatarNotificationModalState,

  // Check should show
  on(AvatarNotificationModalActions.checkShouldShow, (state) => ({
    ...state,
    loading: { ...state.loading, checkingShouldShow: true },
    error: null
  })),

  on(
    AvatarNotificationModalActions.checkShouldShowSuccess,
    (state, { shouldShow, reason }) => ({
      ...state,
      shouldShow,
      reason,
      isModalOpen: shouldShow,
      loading: { ...state.loading, checkingShouldShow: false }
    })
  ),

  on(
    AvatarNotificationModalActions.checkShouldShowFailed,
    (state, { error }) => ({
      ...state,
      error,
      loading: { ...state.loading, checkingShouldShow: false }
    })
  ),

  // Record interaction
  on(AvatarNotificationModalActions.recordInteraction, (state) => ({
    ...state,
    loading: { ...state.loading, recordingInteraction: true }
  })),

  on(AvatarNotificationModalActions.recordInteractionSuccess, (state) => ({
    ...state,
    loading: { ...state.loading, recordingInteraction: false }
  })),

  on(
    AvatarNotificationModalActions.recordInteractionFailed,
    (state, { error }) => ({
      ...state,
      error,
      loading: { ...state.loading, recordingInteraction: false }
    })
  ),

  // Modal state
  on(AvatarNotificationModalActions.setModalOpen, (state, { isOpen }) => ({
    ...state,
    isModalOpen: isOpen
  })),

  // Reset
  on(
    AvatarNotificationModalActions.resetState,
    () => avatarNotificationModalState
  )
);
